import { render, staticRenderFns } from "./Notificaciones.vue?vue&type=template&id=2a21fb04&scoped=true&"
import script from "./Notificaciones.vue?vue&type=script&lang=ts&"
export * from "./Notificaciones.vue?vue&type=script&lang=ts&"
import style0 from "./Notificaciones.vue?vue&type=style&index=0&id=2a21fb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21fb04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2a21fb04', component.options)
    } else {
      api.reload('2a21fb04', component.options)
    }
    module.hot.accept("./Notificaciones.vue?vue&type=template&id=2a21fb04&scoped=true&", function () {
      api.rerender('2a21fb04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/Notificaciones.vue"
export default component.exports